/* ============================================================
   Custom Cart Drawer JS — Artesini (Dawn OS 2.0)
   Adapted from Todd Wexler's Impulse-based cart drawer.
   Uses Dawn's window.routes and section rendering.
   ============================================================ */

(function() {
  'use strict';

  var CONFIG = {
    storageKey: 'artesini_shipping_protection',
    tiers: [
      { spend: 8500, save: 1000 },   // $85 → save $10
      { spend: 13000, save: 2000 },  // $130 → save $20
      { spend: 20000, save: 3000 }   // $200 → save $30
    ]
  };

  var CustomCartDrawer = {
    initialized: false,
    isUpdating: false,
    hasAutoAdded: false,
    recsLoaded: false,
    lastRecsProductId: null,

    init: function() {
      if (this.initialized) return;
      this.initialized = true;

      this.observeDrawer();
      this.bindEvents();
      this.styleExpressButtons();

      var self = this;
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
          // Always fetch full cart to ensure complete discount properties are loaded
          self.fetchCart(function(fullCart) {
            self.updateTiers(fullCart);
            self.updatePricing(fullCart);
            self.loadRecommendations(fullCart);
          });
        });
      }
    },

    /* ==========================================
       Drawer Observer — detect open/close
       ========================================== */

    observeDrawer: function() {
      var drawerEl = document.querySelector('cart-drawer');
      if (!drawerEl) return;

      var self = this;

      // Watch for drawer open/close
      var attrObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'class') {
            if (drawerEl.classList.contains('active')) {
              self.onDrawerOpen();
            }
          }
        });
      });
      attrObserver.observe(drawerEl, { attributes: true });
    },

    /* ==========================================
       Event Binding
       ========================================== */

    bindEvents: function() {
      var self = this;

      // Protection toggle handler
      document.addEventListener('change', function(evt) {
        if (evt.target && evt.target.id === 'ShippingProtectionToggle') {
          evt.stopPropagation();
          self.toggleProtection(evt.target.checked);
        }
      });

      // Recommendation "Add" button handler
      document.addEventListener('click', function(evt) {
        var addBtn = evt.target.closest('.cart-drawer__rec-add');
        if (!addBtn) return;

        var variantId = addBtn.getAttribute('data-variant-id');
        if (!variantId) return;

        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';

        fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
        })
        .then(function() {
          self.recsLoaded = false;
          self.refreshCartDrawer();
        })
        .catch(function() {
          addBtn.disabled = false;
          addBtn.textContent = '+ Add';
        });
      });
    },

    /* ==========================================
       Drawer Open Handler
       ========================================== */

    onDrawerOpen: function() {
      var self = this;

      this.fetchCart(function(cart) {
        self.syncProtectionUI(cart);
        self.updatePricing(cart);
        self.loadRecommendations(cart);
        self.updateTiers(cart);

        // Auto-add protection if user hasn't unchecked
        var protectionVariantId = self.getProtectionVariantId();
        if (protectionVariantId) {
          var hasProtection = self.cartHasProtection(cart, protectionVariantId);
          var shouldProtect = self.getProtectionState();

          if (shouldProtect && !hasProtection && !self.hasAutoAdded) {
            self.hasAutoAdded = true;
            self.addProtectionToCart(protectionVariantId);
          }
        }
      });

      this.styleExpressButtons();
      setTimeout(function() { self.styleExpressButtons(); }, 500);
      setTimeout(function() { self.styleExpressButtons(); }, 1500);
      setTimeout(function() { self.styleExpressButtons(); }, 3000);
    },

    /* ==========================================
       Cart Fetching
       ========================================== */

    fetchCart: function(callback) {
      fetch(window.routes.cart_url + '.js', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(cart) { if (callback) callback(cart); })
        .catch(function() {});
    },

    refreshCartDrawer: function() {
      var self = this;
      fetch(window.routes.cart_url + '?section_id=cart-drawer')
        .then(function(r) { return r.text(); })
        .then(function(responseText) {
          var html = new DOMParser().parseFromString(responseText, 'text/html');
          var selectors = ['cart-drawer-items', '.drawer__footer'];
          for (var i = 0; i < selectors.length; i++) {
            var target = document.querySelector(selectors[i]);
            var source = html.querySelector(selectors[i]);
            if (target && source) target.replaceWith(source);
          }

          // Update cart icon bubble
          fetch(window.routes.cart_url + '?section_id=cart-icon-bubble')
            .then(function(r) { return r.text(); })
            .then(function(bubbleText) {
              var bubbleHtml = new DOMParser().parseFromString(bubbleText, 'text/html');
              var bubbleTarget = document.getElementById('cart-icon-bubble');
              var bubbleSource = bubbleHtml.querySelector('.shopify-section');
              if (bubbleTarget && bubbleSource) bubbleTarget.innerHTML = bubbleSource.innerHTML;
            })
            .catch(function() {});

          // Update empty state
          var cartDrawer = document.querySelector('cart-drawer');
          var drawerItems = document.querySelector('cart-drawer-items');
          if (cartDrawer && drawerItems) {
            if (drawerItems.classList.contains('is-empty')) {
              cartDrawer.classList.add('is-empty');
            } else {
              cartDrawer.classList.remove('is-empty');
            }
          }

          // Re-init after DOM replacement
          setTimeout(function() {
            self.styleExpressButtons();
            self.fetchCart(function(cart) {
              self.syncProtectionUI(cart);
              self.updatePricing(cart);
              self.loadRecommendations(cart);
              self.updateTiers(cart);
            });
          }, 200);
        })
        .catch(function() {});
    },

    /* ==========================================
       Express Checkout — Horizontal Grid
       ========================================== */

    styleExpressButtons: function() {
      var expressContainer = document.querySelector('.cart-drawer__express');
      if (!expressContainer) return;

      if (expressContainer.querySelector('.cart-drawer__express-grid')) return;

      var accelCheckout = expressContainer.querySelector('shopify-accelerated-checkout-cart');
      if (!accelCheckout) return;

      var buttons = accelCheckout.querySelectorAll('shop-pay-wallet-button, shopify-paypal-button, shopify-google-pay-button, google-pay-button');
      if (buttons.length === 0) return;

      var grid = document.createElement('div');
      grid.className = 'cart-drawer__express-grid';

      buttons.forEach(function(btn) {
        grid.appendChild(btn);
      });

      var origContainer = expressContainer.querySelector('.additional-checkout-buttons--vertical');
      if (origContainer) origContainer.classList.add('is-extracted');

      expressContainer.appendChild(grid);
    },

    /* ==========================================
       Pricing Summary — dynamic update
       ========================================== */

    formatMoney: function(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    updatePricing: function(cart) {
      if (!cart || !Array.isArray(cart.items)) return;
      var pricingEl = document.querySelector('.cart-drawer__pricing');
      if (!pricingEl) return;

      var discounts = cart.cart_level_discount_applications || [];
      var html = '';

      if (discounts.length > 0) {
        html += '<div class="cart-drawer__pricing-row">';
        html += '<span class="cart-drawer__pricing-label">Subtotal</span>';
        html += '<span class="cart-drawer__pricing-original">' + this.formatMoney(cart.original_total_price) + '</span>';
        html += '</div>';

        for (var i = 0; i < discounts.length; i++) {
          var title = discounts[i].title || discounts[i].name || discounts[i].code || 'Discount';
          var amount = discounts[i].total_allocated_amount;
          if (typeof amount === 'undefined' || amount === null) {
            amount = discounts[i].amount;
          }
          if ((typeof amount === 'undefined' || amount === null || isNaN(amount)) && discounts.length === 1) {
            amount = cart.total_discount;
          }
          if (typeof amount === 'undefined' || amount === null || isNaN(amount)) {
            amount = 0;
          }

          html += '<div class="cart-drawer__pricing-row">';
          html += '<span class="cart-drawer__pricing-label cart-drawer__pricing-discount-name">' + title + '</span>';
          html += '<span class="cart-drawer__pricing-discount-amount">-' + this.formatMoney(amount) + '</span>';
          html += '</div>';
        }

        html += '<div class="cart-drawer__pricing-row cart-drawer__pricing-total-row">';
        html += '<span class="cart-drawer__pricing-label">Total</span>';
        html += '<span class="cart-drawer__pricing-total cart-drawer__pricing-total--red" data-subtotal>' + this.formatMoney(cart.total_price) + '</span>';
        html += '</div>';
      } else {
        html += '<div class="cart-drawer__pricing-row cart-drawer__pricing-total-row">';
        html += '<span class="cart-drawer__pricing-label">Subtotal</span>';
        html += '<span class="cart-drawer__pricing-total" data-subtotal>' + this.formatMoney(cart.total_price) + '</span>';
        html += '</div>';
      }

      pricingEl.innerHTML = html;
    },

    /* ==========================================
       Tiered Discount Progress Bar
       ========================================== */

    updateTiers: function(cart) {
      if (!cart || !Array.isArray(cart.items)) return;
      var progressEl = document.querySelector('[data-tier-progress]');
      var msgEl = document.querySelector('[data-tier-msg]');
      var fillEl = document.querySelector('[data-tier-fill]');
      if (!progressEl || !msgEl || !fillEl) return;

      // Calculate subtotal excluding shipping protection
      var subtotal = 0;
      var protectionVariantId = this.getProtectionVariantId();
      cart.items.forEach(function(item) {
        if (!protectionVariantId || item.variant_id !== protectionVariantId) {
          subtotal += item.final_line_price;
        }
      });

      var tiers = CONFIG.tiers;
      var maxSpend = tiers[tiers.length - 1].spend;

      // Find highest reached tier and next tier
      var reachedIndex = -1;
      for (var i = tiers.length - 1; i >= 0; i--) {
        if (subtotal >= tiers[i].spend) {
          reachedIndex = i;
          break;
        }
      }

      // Calculate fill percentage
      var fillPct = Math.min((subtotal / maxSpend) * 100, 100);
      fillEl.style.width = fillPct + '%';

      // Toggle green fill when at least first tier is reached
      if (reachedIndex >= 0) {
        fillEl.classList.add('is-active');
      } else {
        fillEl.classList.remove('is-active');
      }

      // Update milestone markers
      for (var j = 0; j < tiers.length; j++) {
        var marker = document.querySelector('[data-tier-marker="' + j + '"]');
        if (!marker) continue;
        if (j <= reachedIndex) {
          marker.classList.add('is-reached');
        } else {
          marker.classList.remove('is-reached');
        }
      }

      // Update motivational message
      var nextIndex = reachedIndex + 1;
      if (subtotal === 0) {
        msgEl.innerHTML = 'Add items to unlock savings!';
      } else if (nextIndex < tiers.length) {
        var next = tiers[nextIndex];
        var remaining = ((next.spend - subtotal) / 100).toFixed(2).replace(/\.00$/, '');
        msgEl.innerHTML = 'Spend <strong>$' + remaining + ' more</strong> to save <strong>$' + (next.save / 100) + '</strong>';
      } else {
        // All tiers reached
        msgEl.innerHTML = 'Maximum savings unlocked!';
      }
    },

    /* ==========================================
       Shipping Protection
       ========================================== */

    getProtectionVariantId: function() {
      var toggle = document.getElementById('ShippingProtectionToggle');
      if (!toggle) return null;
      var id = toggle.getAttribute('data-variant-id');
      return id ? parseInt(id) : null;
    },

    getProtectionState: function() {
      var stored = localStorage.getItem(CONFIG.storageKey);
      if (stored === null) return true;
      return stored === 'true';
    },

    setProtectionState: function(state) {
      localStorage.setItem(CONFIG.storageKey, state ? 'true' : 'false');
    },

    cartHasProtection: function(cart, variantId) {
      return cart.items.some(function(item) {
        return item.variant_id === variantId;
      });
    },

    syncProtectionUI: function(cart) {
      var variantId = this.getProtectionVariantId();
      if (!variantId) return;
      var hasProtection = this.cartHasProtection(cart, variantId);
      var toggle = document.getElementById('ShippingProtectionToggle');
      if (toggle) toggle.checked = hasProtection;
    },

    toggleProtection: function(isOn) {
      if (this.isUpdating) return;
      this.isUpdating = true;
      this.setProtectionState(isOn);

      var variantId = this.getProtectionVariantId();
      if (!variantId) { this.isUpdating = false; return; }

      var self = this;
      if (isOn) {
        this.addProtectionToCart(variantId, function() { self.isUpdating = false; });
      } else {
        this.removeProtectionFromCart(variantId, function() { self.isUpdating = false; });
      }
    },

    addProtectionToCart: function(variantId, callback) {
      var self = this;
      this.fetchCart(function(cart) {
        if (self.cartHasProtection(cart, variantId)) {
          if (callback) callback();
          return;
        }

        fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
        .then(function() {
          self.refreshCartDrawer();
          if (callback) callback();
        })
        .catch(function() { if (callback) callback(); });
      });
    },

    removeProtectionFromCart: function(variantId, callback) {
      var self = this;
      this.fetchCart(function(cart) {
        var item = cart.items.find(function(i) {
          return i.variant_id === variantId;
        });
        if (!item) { if (callback) callback(); return; }

        fetch(window.routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: item.key, quantity: 0 })
        })
        .then(function() {
          self.refreshCartDrawer();
          if (callback) callback();
        })
        .catch(function() { if (callback) callback(); });
      });
    },

    /* ==========================================
       You May Also Like — Recommendations
       ========================================== */

    loadRecommendations: function(cart) {
      if (!cart || !Array.isArray(cart.items)) return;
      var container = document.querySelector('[data-cart-recommendations]');
      if (!container) return;

      var scrollEl = container.querySelector('[data-recs-scroll]');
      if (!scrollEl) return;

      var limit = Math.min(parseInt(container.getAttribute('data-recs-limit')) || 3, 3);

      // Get protection variant to exclude from source
      var protectionVariantId = this.getProtectionVariantId();

      // Find first non-protection product
      var sourceItem = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (protectionVariantId && cart.items[i].variant_id === protectionVariantId) continue;
        sourceItem = cart.items[i];
        break;
      }

      if (!sourceItem) {
        container.style.display = 'none';
        return;
      }

      // Don't reload if same product and elements are already rendered
      if (this.recsLoaded && this.lastRecsProductId === sourceItem.product_id && scrollEl.children.length > 0) {
        container.style.display = '';
        return;
      }

      this.lastRecsProductId = sourceItem.product_id;
      var self = this;

      // Collect IDs of items already in cart
      var cartProductIds = {};
      cart.items.forEach(function(item) {
        cartProductIds[item.product_id] = true;
      });

      fetch('/recommendations/products.json?product_id=' + sourceItem.product_id + '&limit=' + (limit + 5))
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var products = (data.products || []).filter(function(p) {
            return !cartProductIds[p.id];
          }).slice(0, limit);

          if (products.length === 0) {
            container.style.display = 'none';
            return;
          }

          scrollEl.innerHTML = '';
          products.forEach(function(product) {
            var imgSrc = product.featured_image ? product.featured_image.replace(/\.(jpg|png|jpeg|gif|webp)/, '_300x.$1') : '';
            var price = (product.price / 100).toFixed(2);
            var comparePrice = product.compare_at_price ? (product.compare_at_price / 100).toFixed(2) : null;
            var variantId = product.variants && product.variants[0] ? product.variants[0].id : null;

            var card = document.createElement('div');
            card.className = 'cart-drawer__rec-card';
            card.innerHTML =
              '<a href="' + product.url + '" class="cart-drawer__rec-img-wrap">' +
                (imgSrc ? '<img src="' + imgSrc + '" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
              '</a>' +
              '<div class="cart-drawer__rec-info">' +
                '<a href="' + product.url + '" class="cart-drawer__rec-title">' + product.title + '</a>' +
                '<div class="cart-drawer__rec-price">' +
                  (comparePrice ? '<span class="cart-drawer__rec-compare">$' + comparePrice + '</span> ' : '') +
                  '<span' + (comparePrice ? ' class="cart-drawer__rec-sale"' : '') + '>$' + price + '</span>' +
                '</div>' +
                (variantId ? '<button type="button" class="cart-drawer__rec-add" data-variant-id="' + variantId + '">+ Add</button>' : '') +
              '</div>';

            scrollEl.appendChild(card);
          });

          container.style.display = '';
          self.recsLoaded = true;
        })
        .catch(function() {
          container.style.display = 'none';
        });
    }
  };

  /* ==========================================
     Initialize
     ========================================== */

  function onReady() {
    CustomCartDrawer.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  function interceptCartDrawer() {
    if (typeof CartDrawer !== 'undefined' && CartDrawer.prototype) {
      if (CartDrawer.prototype.renderContents && !CartDrawer.prototype.renderContents.isIntercepted) {
        var originalRenderContents = CartDrawer.prototype.renderContents;
        CartDrawer.prototype.renderContents = function(parsedState) {
          originalRenderContents.call(this, parsedState);
          if (window.CustomCartDrawer) {
            window.CustomCartDrawer.fetchCart(function(cart) {
              window.CustomCartDrawer.syncProtectionUI(cart);
              window.CustomCartDrawer.updatePricing(cart);
              window.CustomCartDrawer.loadRecommendations(cart);
              window.CustomCartDrawer.updateTiers(cart);
            });
            window.CustomCartDrawer.styleExpressButtons();
          }
        };
        CartDrawer.prototype.renderContents.isIntercepted = true;
        return true;
      }
    }
    return false;
  }

  interceptCartDrawer();
  document.addEventListener('DOMContentLoaded', interceptCartDrawer);
  var interceptAttempts = 0;
  var interceptInterval = setInterval(function() {
    interceptAttempts++;
    if (interceptCartDrawer() || interceptAttempts > 60) {
      clearInterval(interceptInterval);
    }
  }, 50);

  window.CustomCartDrawer = CustomCartDrawer;
})();
